<div id="confirmation-dialog" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="10px">
	<div mat-dialog-title>
		<mat-icon class="dialog-title-icon">info</mat-icon>
		<span class="dialog-title-text">{{titleLabel | translate}}</span>
	</div>
	<div id="confirmation-dialog-content" mat-dialog-content>
		<ng-content></ng-content>
	</div>
	<div mat-dialog-actions fxLayout="column" fxLayoutAlign="center">
		<div fxLayout="row" fxLayoutAlign="center">
			<nc-button [label]="buttonLabel" mat-dialog-close></nc-button>
		</div>
	</div>
</div>
